<template>
  <div class="home">
    <el-row :gutter="10">
      <el-col
        :xs="24"
        :sm="12"
        :md="8"
        :lg="8"
        :xl="6"
        v-for="(x, i) in list"
        v-bind:key="i"
      >
        <ProductCard class="ProductCard" v-bind="x"></ProductCard>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped>
/* .space {
  height: 44px;
  background-color: #ffffff;
} */
.el-col {
  border-radius: 4px;
  padding: 32px 0;
}
.ProductCard {
  margin: 0 auto;
}
.home {
  width: calc(100% - 32px);
  max-width: 1366px;
  margin: 0 auto;
  background-color: #ffffff;
  overflow: hidden;
  margin-top: 32px;
  margin-bottom: 132px;
}
</style>

<script>
import { pros } from "@/assets/productions.js";
import ProductCard from "@/components/ProductCard.vue";

export default {
  name: "Things",
  components: {
    ProductCard
  },
  data() {
    return {
      list: pros
    };
  }
};
</script>
